import type { ReactNode } from "react";
import { cn } from "@tellescope/design-system";

export interface SortableBlockRowsProps {
  isDragging: boolean;
  children: ReactNode;
}

export const SortableBlockRows = ({ isDragging, children }: SortableBlockRowsProps) => (
  <div className={cn("space-y-2", isDragging && "pointer-events-none")}>{children}</div>
);
